import CombinedRippleEffect from './components/CombinedRippleEffect';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import ReviewList from './components/ReviewList';
import PainDiary2 from './components/PainDiary2';
import PainDiary from './components/PainDiary';
import LandingPage from './components/LandingPage';
import Toast from './components/Toast';
import ReviewFormWrapper from './components/ReviewFormWrapper';
import DiaryEntryWrapper from './components/DiaryEntryWrapper';
import UpdateFormWrapper from './components/UpdateFormWrapper';
import UsernamePrompt from './components/UsernamePrompt';
import LoginPromptModal from './components/LoginPromptModal';
import Header from './components/Header';
import Notifications from './components/Notifications';
import './components/LoginPromptModal.css';
import { api } from './services/api';
import SignUpModal from './components/SignUpModal';
import EmailVerification from './components/EmailVerification';
import PrivacyRedirect from './components/PrivacyRedirect';
import ImagesPage from './components/ImagesPage';
import UploadImages from './components/UploadImages';
import SharesPage from './components/SharesPage';
import SharedImagesPage from './components/SharedImagesPage';

function ProtectedRoute({ children, isLoggedIn }) {
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }
  return children;
}


function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code');
  const stateParam = queryParams.get('state');
  const [user, setUser] = useState(() => {
    const userJson = localStorage.getItem('user');
    return userJson ? JSON.parse(userJson) : null;
  });
  const [showUsernamePrompt, setShowUsernamePrompt] = useState(false);
  const [usernameError, setUsernameError] = useState('');
  const [pendingFacebookAuth, setPendingFacebookAuth] = useState(null);
  const [showLoginPrompt, setShowLoginPrompt] = useState(false);
  const [loginTriggeredByCreateReview, setLoginTriggeredByCreateReview] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [loginMessage, setLoginMessage] = useState("");
  const [userReviews, setUserReviews] = useState([]);
  const [facebookProfileName, setFacebookProfileName] = useState("")
  const [facebookProfileImage, setFacebookProfileImage] = useState("")
  const [savingLogin, setSavingLogin] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');
  const [notifications, setNotifications] = useState([]);
  const [hasCalledNotifications, setHasCalledNotifications] = useState(false);
  const [isAuthChecked, setIsAuthChecked] = useState(false);

  const isLandingPage = location.pathname === '/';

  useEffect(() => {
    checkLoginState();
    document.addEventListener('touchmove', function (e) {
      if (!e.target.closest('.scrollable')) {
        e.preventDefault();
      }
    }, { passive: false });

    return () => {

    };
  }, []);

  useEffect(() => {
    if (code && !user && !savingLogin) {
      setSavingLogin(true)
      console.log("GOT CODE EXCHANGING FOR TOKEN: ", code)
      api.exchangeCode(code)
        .then(res => {
          if (res.isValid && res.userExists) {
            saveUserNoop(res)
            if (stateParam) {
              try {
                const { returnTo } = JSON.parse(decodeURIComponent(stateParam));
                if (returnTo) {

                  console.log("return to url was ", returnTo)
                  navigate(returnTo.replace(window.location.origin, ''), { replace: true });
                }
              } catch (err) {
                console.error('Invalid state param:', err);
              }
            }
          }
          if (res.isValid && !res.userExists) {
            console.log("NEW USER WITH RES: ", JSON.parse(JSON.stringify(res)))
            setFacebookProfileImage(res.picture)
            setPendingFacebookAuth({ accessToken: res.token, userID: res.userID })
            setFacebookProfileName(res.name)
            setShowUsernamePrompt(true);
          }
        })
        .finally(() => setSavingLogin(false))
    }
  }, [code])

  useEffect(() => {
    if (!!user && !hasCalledNotifications) {
      try {
        setHasCalledNotifications(true);
        readNotifications()
      } catch (error) {
        console.error("API call failed:", error);
      }
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      api.getReviews("", user.id)
        .then((res) => {
          setUserReviews(res)
        }).catch(error => {
          console.error('Error fetching user reviews:', error);
        })
    }
  }, [user]);

  const readNotifications = () => {
    try {
      setHasCalledNotifications(true);
      api.getNotifications().then(notifications => {
        setNotifications(notifications ? notifications : [])
      })
    } catch (error) {
      console.error("API call failed:", error);
    }
  }

  const checkLoginState = () => {
    const token = localStorage.getItem('authToken');
    const userJson = localStorage.getItem('user');
    if (token && userJson) {
      setUser(JSON.parse(userJson));
    }
    setIsAuthChecked(true);
  };

  const handleLogin = async (email, password) => {
    setSavingLogin(true)
    try {
      const data = await api.validateEmailAuth(email, password)
      if (data.isValid && data.userExists) {
        saveUserNoop(data)
      }
      setSavingLogin(false)
      return data
    } catch (error) {
      setSavingLogin(false)
      console.error(error)
      throw error
    }
  }


  const handleFacebookLogin = () => {
    const origin = window.location.origin;
    let redirectUri = `${origin}/login/callback`;
    const state = encodeURIComponent(JSON.stringify({ returnTo: window.location.href }));
    const facebookAuthUrl = `https://www.facebook.com/v18.0/dialog/oauth?client_id=1193876548992652&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&scope=email&response_type=code&state=${state}`;
    window.location.href = facebookAuthUrl;
  };

  const saveUserNoop = (data) => {
    saveUser(data, () => {
      return null
    })
  }

  const saveUser = (data, callback) => {
    localStorage.setItem('authToken', data.token);
    api.getCurrentUser()
      .then(userData => {
        localStorage.setItem('user', JSON.stringify(userData));
        setUser(userData);
        setShowUsernamePrompt(false);
        setPendingFacebookAuth(null);
        setShowLoginPrompt(false);
        setShowSignUpModal(false);
        if (loginTriggeredByCreateReview) {
          navigate('/create-review');
          setLoginTriggeredByCreateReview(false);
        }
        return callback()
      })
      .catch(error => {
        console.error('Error fetching user data:', error);
      })
  }

  const handleFacebookUsernameSubmit = async (username, image, background) => {
    if (!pendingFacebookAuth) {
      setUsernameError('No pending Facebook authentication');
      return;
    }

    try {
      const data = await api.createPatient(
        pendingFacebookAuth.userID,
        username,
        pendingFacebookAuth.accessToken,
        image,
        background
      );

      saveUser(data, () => {
        setToastMessage('Account created successfully!');
        setShowToast(true);
        if (stateParam) {
          try {
            const { returnTo } = JSON.parse(decodeURIComponent(stateParam));
            if (returnTo) {
              navigate(returnTo.replace(window.location.origin, ''), { replace: true });
            }
          } catch (err) {
            console.error('Invalid state param:', err);
          }
        }
      })
    } catch (error) {
      console.error('Error:', error);
      setUsernameError(error.response?.data?.error || 'Failed to create account');
    }
  };

  // toast renders the global Toast component. `variant` defaults to
  // 'success' (green) for backwards compatibility; pass 'warning' for the
  // yellow style used for non-fatal alerts like skipped duplicates.
  const toast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  }

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    setLoginTriggeredByCreateReview(false);
    setUser(null);
  };

  const handleCreateReviewClick = () => {
    if (!user) {
      setLoginMessage("In order to create a review you must be logged in.")
      setLoginTriggeredByCreateReview(true);
      setShowLoginPrompt(true);
      setSavingLogin(false)
    } else {
      navigate('/create-review');
    }
  };

  const replyLogin = () => {
    setLoginMessage("In order to post a comment you must be logged in")
    setShowLoginPrompt(true);
    setSavingLogin(false)
  }

  const saveImagesLogin = () => {
    setLoginMessage("In order to save images you must be logged in.")
    setShowLoginPrompt(true);
    setSavingLogin(false)
  }

  const uploadImagesLogin = () => {
    setLoginMessage("In order to upload images you must be logged in.")
    setShowLoginPrompt(true);
    setSavingLogin(false)
  }

  const viewSharesLogin = () => {
    setLoginMessage("In order to view your shares you must be logged in.")
    setShowLoginPrompt(true);
    setSavingLogin(false)
  }

  const handleLoginPromptClose = () => {
    if (location.pathname === "/diary") {
      navigate("/");
    }
    setShowLoginPrompt(false);
  };

  const handleProfilePromptClose = () => {
    setShowUsernamePrompt(false);
  }

  const loginClick = () => {
    setLoginMessage("");
    setShowLoginPrompt(true);
    setSavingLogin(false)
  }

  const handleShowSignUp = () => {
    setShowLoginPrompt(false);
    setShowSignUpModal(true);
  };

  const handleSignUpModalClose = () => {
    setShowSignUpModal(false);
  };

  const handleShowUpdateForm = () => {
    if (!user) {
      setLoginMessage("In order to post an update you must be logged in.");
      setShowLoginPrompt(true);
      setSavingLogin(false)
      return;
    }

    navigate('/update')
  };

  if (!isAuthChecked) {
    return null;
  }

  // TODO: THIS IS HACKY
  const isDiaryPage = location.pathname.startsWith("/diary") && !location.pathname.startsWith("/diary/entry");

  return (
    <div className={`App scrollable ${isLandingPage ? 'landing' : ''}`} style={{ height: '100dvh' }}>
      {isLandingPage && (
        <div
          id="ripple-container"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            overflow: 'hidden',
            pointerEvents: 'none',
            zIndex: 1,
          }}
        ></div>
      )}
      {isLandingPage && (<CombinedRippleEffect />)}
      <div id="modal-container"></div>
      {showToast && (
        <Toast
          message={toastMessage}
          variant={toastVariant}
          onClose={() => setShowToast(false)}
        />
      )}
      {!isLandingPage && (
        <Header
          userReviews={userReviews}
          onLogout={handleLogout}
          onShowLoginPrompt={loginClick}
          onCreateReviewClick={handleCreateReviewClick}
          onShowUpdateForm={() => handleShowUpdateForm()}
          notifications={notifications}
          user={user}
        />
      )}
      <main
        className="App-main"
        style={isDiaryPage ? { padding: 0, margin: 0, maxWidth: "100%" } : {}}
      >
        <Routes>
          <Route path="/login/callback" element={
            <div>...Signing in</div>
          }
          />
          <Route path="/privacy" element={<PrivacyRedirect />} />
          <Route path="/"
            element={
              <LandingPage
                showLoginPrompt={showLoginPrompt}
                closeLoginPrompt={handleLoginPromptClose}
                showSignupModal={showSignUpModal}
                closeSignupModal={handleSignUpModalClose}
                showUsernamePrompt={showUsernamePrompt}
                closeProfilePrompt={handleProfilePromptClose}
              />
            }
          />
          <Route path="/surgeries"
            element={<ReviewList
              user={user}
              onLogin={replyLogin}
              onRegularLogin={loginClick}
              toast={toast}
            />}
          />
          <Route path="/images" element={<ImagesPage toast={toast} />} />
          <Route path="/images/shares" element={
            <SharesPage
              toast={toast}
              user={user}
              onLogin={viewSharesLogin}
            />}
          />
          <Route path="/share/:token" element={<SharedImagesPage toast={toast} />} />
          <Route path="/images/upload" element={
            <UploadImages
              toast={toast}
              user={user}
              onLogin={saveImagesLogin}
              onUploadLogin={uploadImagesLogin}
            />}
          />
          <Route path="/diary"
            element={<PainDiary
              user={user}
              toast={toast}
              closeLoginPrompt={handleLoginPromptClose}
              closeProfilePrompt={handleProfilePromptClose}
              openLoginPrompt={loginClick}
              showLoginPrompt={showLoginPrompt}
              showSignupModal={showSignUpModal}
              showUsernamePrompt={showUsernamePrompt}
            />}
          />
          <Route path="/diary/:id"
            element={<PainDiary
              user={user}
              toast={toast}
              openLoginPrompt={loginClick}
              showLoginPrompt={showLoginPrompt}
            />}
          />

          {/* TODO: SHOULD THIS BE PROTECTED? */}
          <Route path="/diary/entry"
            element={<DiaryEntryWrapper user={user} toast={toast} />}
          />
          <Route path="/diary/entry/:id"
            element={<DiaryEntryWrapper user={user} toast={toast} />}
          />
          <Route
            path="/create-review"
            element={
              <ProtectedRoute isLoggedIn={!!user}>
                <ReviewFormWrapper user={user} toast={toast} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/review/:id/edit"
            element={
              <ProtectedRoute isLoggedIn={!!user}>
                <ReviewFormWrapper user={user} toast={toast} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/:surgery/update"
            element={
              <ProtectedRoute isLoggedIn={!!user}>
                <UpdateFormWrapper
                  toast={toast}
                  user={user}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/update/:id/edit"
            element={
              <ProtectedRoute isLoggedIn={!!user}>
                <UpdateFormWrapper
                  toast={toast}
                  user={user}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute isLoggedIn={!!user}>
                <Notifications
                  notifications={notifications}
                  loadNotifications={readNotifications}
                />
              </ProtectedRoute>
            }
          />
          <Route path="/verify-email" element={<EmailVerification saveUser={saveUserNoop} toast={toast} />} />
        </Routes>
      </main>
      <UsernamePrompt
        isOpen={showUsernamePrompt}
        onSubmit={handleFacebookUsernameSubmit}
        error={usernameError}
        facebookProfileName={facebookProfileName}
        setFacebookProfileName={setFacebookProfileName}
        facebookProfileImage={facebookProfileImage}
        onClose={handleProfilePromptClose}
      />
      <LoginPromptModal
        isOpen={showLoginPrompt}
        onClose={handleLoginPromptClose}
        onFacebookLogin={handleFacebookLogin}
        onLogin={handleLogin}
        onShowSignUp={handleShowSignUp}
        message={loginMessage}
        saving={savingLogin}
      />
      <SignUpModal
        isOpen={showSignUpModal}
        onClose={handleSignUpModalClose}
        onFacebookSignUp={handleFacebookLogin}
      />
    </div>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}

export default AppWrapper;
